import React from "react";
import { Text, Flex } from "@jsq/ds/core";
import { DetailedEftPaymentPrefObjectType } from "../../../common/types";
import FormattedAddress from "../FormattedAddress";
import PaymentDetailsModalField from "../PaymentDetailsModalField";
import { EftVisibleFields } from "../types";
import { getAddress } from "../utils";
import { isEftFieldVisible } from "../utils/fieldVisibility";

export type EftPaymentPrefDisplayProps = {
  eftPaymentPrefFull: DetailedEftPaymentPrefObjectType;
  visibleFields?: EftVisibleFields;
};

export const EftPaymentPrefDisplay: React.FC<EftPaymentPrefDisplayProps> = ({
  eftPaymentPrefFull,
  visibleFields,
}: EftPaymentPrefDisplayProps) => {
  const accountHolderAddress =
    eftPaymentPrefFull.accountHolderAddress &&
    getAddress(eftPaymentPrefFull.accountHolderAddress);

  const gap = 8; // gap between rows and columns

  return (
    <Flex gap={gap} flexDirection="column" data-testid="EftPaymentPrefDisplayFlex">
      <PaymentDetailsModalField
        label="Account holder name"
        value={eftPaymentPrefFull.accountName}
        gap={gap}
        visible={isEftFieldVisible("accountName", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Bank name"
        value={eftPaymentPrefFull.bank?.name}
        gap={gap}
        visible={isEftFieldVisible("bank", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Institution number"
        value={eftPaymentPrefFull.bank?.institutionNumber}
        gap={gap}
        visible={isEftFieldVisible("bank", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Transit number"
        value={eftPaymentPrefFull.bank?.transitNumber}
        gap={gap}
        visible={isEftFieldVisible("bank", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Account number"
        value={eftPaymentPrefFull.accountNumber}
        gap={gap}
        visible={isEftFieldVisible("accountNumber", visibleFields)}
      />
      {eftPaymentPrefFull.additionalInstructions && (
        <PaymentDetailsModalField
          label="Additional instructions"
          value={eftPaymentPrefFull.additionalInstructions}
          gap={gap}
          visible={isEftFieldVisible("additionalInstructions", visibleFields)}
        />
      )}
      {isEftFieldVisible("accountHolderAddress", visibleFields) && (
        <Flex gap={gap}>
          <Flex flexBasis="60%">
            <Text variant="secondary-md">Account holder address</Text>
          </Flex>
          <Flex flexBasis="100%" flexDirection="column">
            {accountHolderAddress && (
              <FormattedAddress address={accountHolderAddress} variant="regular-md" />
            )}
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
